import { render, staticRenderFns } from "./DashboardLector.vue?vue&type=template&id=43b7969c&"
import script from "./DashboardLector.vue?vue&type=script&lang=js&"
export * from "./DashboardLector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports